import { getFeaturePlan } from './api';

export const FEATURES_PLAN = {
  cacheKey: 'FEATURES_PLAN',
  apiFunction: () => getFeaturePlan()
};
